module.exports = __webpack_public_path__ + "img/icon38.2cca5c39.png";